import { render, staticRenderFns } from "./ReportingV2.vue?vue&type=template&id=7e78e4de&scoped=true&lang=pug"
import script from "./ReportingV2.vue?vue&type=script&lang=js"
export * from "./ReportingV2.vue?vue&type=script&lang=js"
import style0 from "./ReportingV2.vue?vue&type=style&index=0&id=7e78e4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e78e4de",
  null
  
)

export default component.exports